import React from 'react';
import {SongList} from '../../components/SongList';
import {Platform} from '../../../../../types';
import {useQuery} from '@apollo/react-hooks';
import {useObsidianContext} from '../../../../../context/ObsidianProvider';
import {LIBRARY_SONGS_QUERY} from './graphql/LibrarySongsQuery';
import {librarySongs} from './graphql/types/librarySongs';
import {Button} from '../../../..';

export default function Songs() {
  const {data, fetchMore, loading} = useQuery<librarySongs>(
    LIBRARY_SONGS_QUERY,
    {
      variables: {
        limit: 100,
        offset: 0,
      },
    },
  );
  const {obsidian} = useObsidianContext();

  const songs = data?.me?.library?.songs;

  const handleLoadMore = () => {
    if (data?.me?.library?.songs) {
      fetchMore({
        variables: {
          offset: data.me.library.songs.length,
        },
        updateQuery: (prev, {fetchMoreResult}) => {
          if (!fetchMoreResult) return prev;
          console.log(fetchMoreResult);
          const newLibrary = Object.assign({}, prev.me?.library, {
            songs: [
              ...(data?.me?.library?.songs || []),
              ...(fetchMoreResult.me?.library?.songs || []),
            ],
          });
          const newMe = Object.assign({}, prev.me, {library: newLibrary});
          return Object.assign({}, prev, {
            me: newMe,
          });
        },
      });
    }
  };

  return (
    <div>
      {songs && (
        <SongList
          type="song"
          songs={songs}
          onSelect={(song) => obsidian.play(song, Platform.AppleMusic)}
        />
      )}
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Button onClick={handleLoadMore}>Load more</Button>
      )}
    </div>
  );
}
